var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rn-back-top shadowed-border-2",class:{ 'shadowed-border-dark': !_vm.userLogin, 'shadowed-border-light-1': _vm.userLogin },on:{"click":_vm.scrollToTop}},[_c('Icon',{attrs:{"name":"chevron-up","size":"27"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }